<template>
    <div class="form-step">
        <form-question
            ref="questions"
            v-for="question in visibleQuestions"
            :key="question.id"
            :name="question.id"
            :question="question.question"
            :type="question.type"
            :options="question.options"
            :settings="question.settings"
            :multiselect="question.multiselect"
            :form-id="formId"
            :link-code="linkCode"
            @focus="focus"
            @change="questionChanged"
        >
        </form-question>
    </div>
</template>
<script>
import FormQuestion from "./form-question";
import { isQuestionVisible } from "../utils/visibilityConditionEvaluator";

export default {
    name: "step",
    props: {
        questions: Array,
        formId: [String, Number],
    },
    components: {
        "form-question": FormQuestion,
    },
    computed: {
        answers() {
            return this.$store.state.answers;
        },
        linkCode() {
            const linkCode = this.$store.state.linkCode;
            return linkCode ? linkCode.link_code : null;
        },
        visibleQuestions() {
            if (!this.questions) return [];
            return this.questions.filter(question =>
                isQuestionVisible(question, this.answers)
            );
        },
    },
    methods: {
        isValid: function () {
            window.mixpanel?.track("Form step is valid");
            var valid = true;
            for (let q in this.$refs.questions) {
                var question = this.$refs.questions[q];
                if (!question.isValid()) {
                    valid = false;
                }
            }
            return valid;
        },
        questionChanged: function (question) {
            question.isValid();
            this.$store.commit("setAnswer", {
                questionId: question.name,
                value: question.getValue()
            });
            this.$emit("scroll", question.getOffsetTop());
        },
        focus: function (question) {
            this.$emit("scroll", question.getOffsetTop());
        },
    },
};
</script>
